// Curated set of supported cities for onboarding. Each city's streets are
// loaded on demand from OSM, so `place` is a Nominatim-friendly query that
// resolves to the city boundary; `city`/`country` drive the "City, Country"
// label shown in the picker.
export interface SupportedCity {
  city: string;
  country: string;
  place: string;
}

export const SUPPORTED_CITIES: SupportedCity[] = [
  // United States
  { city: "Washington", country: "USA", place: "Washington, D.C., USA" },
  { city: "New York", country: "USA", place: "New York City, New York, USA" },
  {
    city: "San Francisco",
    country: "USA",
    place: "San Francisco, California, USA",
  },
  {
    city: "Los Angeles",
    country: "USA",
    place: "Los Angeles, California, USA",
  },
  { city: "Chicago", country: "USA", place: "Chicago, Illinois, USA" },
  { city: "Boston", country: "USA", place: "Boston, Massachusetts, USA" },
  { city: "Seattle", country: "USA", place: "Seattle, Washington, USA" },
  { city: "Austin", country: "USA", place: "Austin, Texas, USA" },

  // Europe
  {
    city: "London",
    country: "United Kingdom",
    place: "London, United Kingdom",
  },
  { city: "Paris", country: "France", place: "Paris, France" },
  { city: "Barcelona", country: "Spain", place: "Barcelona, Spain" },
  { city: "Madrid", country: "Spain", place: "Madrid, Spain" },
  { city: "Berlin", country: "Germany", place: "Berlin, Germany" },
  { city: "Rome", country: "Italy", place: "Rome, Italy" },
  {
    city: "Amsterdam",
    country: "Netherlands",
    place: "Amsterdam, Netherlands",
  },
  { city: "Lisbon", country: "Portugal", place: "Lisbon, Portugal" },
  { city: "Vienna", country: "Austria", place: "Vienna, Austria" },
  { city: "Brussels", country: "Belgium", place: "Brussels, Belgium" },
  { city: "Copenhagen", country: "Denmark", place: "Copenhagen, Denmark" },
  { city: "Stockholm", country: "Sweden", place: "Stockholm, Sweden" },
  { city: "Dublin", country: "Ireland", place: "Dublin, Ireland" },
  {
    city: "Prague",
    country: "Czech Republic",
    place: "Prague, Czech Republic",
  },
  { city: "Warsaw", country: "Poland", place: "Warsaw, Poland" },
  { city: "Athens", country: "Greece", place: "Athens, Greece" },
];

export const cityLabel = (c: SupportedCity) => `${c.city}, ${c.country}`;
